import { render } from "./wizard-steps.vue?vue&type=template&id=5570543a"
import script from "./wizard-steps.vue?vue&type=script&lang=js"
export * from "./wizard-steps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__